import { Card } from '@tempo-io/sui-card';
import { cn } from '@tempo-io/sui-class-utils';
import type { ComponentProps } from 'react';

export const TABLE_CARD_CHROME_CLASSNAME = 'rounded-md border-0 bg-bg-surface-raised shadow-sm';

export const TableCard = ({ className, ...props }: ComponentProps<typeof Card>) => (
  <Card className={cn(TABLE_CARD_CHROME_CLASSNAME, 'py-0', className)} {...props} />
);
